/**
 * Created by sparakh on 6/8/16.
 */

; (function (EG, document, _) {

	/**
	 * ResponseHandler is responsible for analyzing the response.
	 * It understands the response status code and gives direction to error handler to display success/error messages
	 */

	// Constructor
	var ResponseHandler = function (userServiceResponseList) {
		this.userServiceResponseList = userServiceResponseList;
	};

	ResponseHandler.prototype = {

		/**
		 * This method processes the response. Analyzes whether the response is success
		 * and failure and asks error renderer to render the success/error messgaes
		 */
		processResponse: function (successMsg, errorMsg) {
			var allSuccess = true, success,
				self = this,
				messageList = [], type;

			_.each(this.userServiceResponseList, function (response) {
				success = self.isSuccess(response);
				if (!success && self.isValidationError(response)) {
					messageList.push.apply(messageList, self.extractValidationMessages(response));
				}
				allSuccess = allSuccess && success;
			});

			if (allSuccess) {
				successMsg = successMsg || uitk.i18n.msg("profile_update_successMsg");
				messageList.push(successMsg);
				type = EG.Users.Constants.alertType.SUCCESS;
			} else {
				type = EG.Users.Constants.alertType.ERROR;
				if(errorMsg == null){
				    errorMsg = uitk.i18n.msg("EGE_USERS_ERR_DEFAULT");
				    EG.Users.OmnitureUtil.omnitureTrackSomethingWentWrong();
				}

				if (messageList.length == 0) {
					messageList.push(errorMsg);
				}

				//send error messages to omniture.
				var messageString = self.buildErrorsForOmniture(messageList);
				EG.Users.Profile.userAnalytics.trackErrorMessages(messageString);
			}

			return {
				type: type,
				messageList: messageList
			};
		},

		buildErrorsForOmniture: function (messageList) {
			var errorMessageString = messageList[0];
			for (i = 1; i < messageList.length; i++) {
				var msg = I18n.t(messageList[i]);
				errorMessageString = errorMessageString + '|' + msg;
			}
			return errorMessageString;
		},
		/**
		 * Checks whether the response is success on the basis of status code.
		 */
		isSuccess: function (response) {
			var statusCodeString;
			if (!response.statusCode) {
				return true;
			} else {
				statusCodeString = response.statusCode + "";
				return statusCodeString.indexOf("2") == 0;
			}
		},

		/**
		 * Checks whether the response is because of validation error as per the status code.
		 */
		isValidationError: function (response) {
			return response.statusCode == 400 || response.statusCode == 422;
		},

		/**
		 * Extracts validation messages from the response received from service.
		 */
		extractValidationMessages: function (response) {
			var messages = [];
			if (response.data && response.data.data) {
				_.each(response.data, function (attrObj) {
					if (attrObj.message) {
						messages.push(attrObj.message);
					}
				});
			} else if(response.data) {
				messages.push(EG.Users.Profile.Error.Descriptions[response.data.error_code]);
			}
			return messages;
		}

	};

	/**
	 * Logical entity that contains response data received from service.
	 */
	//Constructor
	var UserServiceResponse = function (response) {
		var responseObj = EG.Users.Utils.parseJson(response.responseText);
		// By default if there is no status code, it is success response
		this.statusCode = response.status || 200;
		this.statusText = response.statusText || EG.Users.Constants.SUCCESS_STATUS;
		this.data = responseObj || (response.responseText ? response.responseText : response);

	};
	UserServiceResponse.prototype = {
		constructor: UserServiceResponse
	};

	EG.Users.Utils.UserServiceResponse = UserServiceResponse;
	EG.Users.Utils.ResponseHandler = ResponseHandler;

})(EG, document, _);
